export default __webpack_public_path__ + "static/media/93ce67e5-64e3-4a99-99a3-545f20c5beec.5867fe24.woff2";